import React, { useEffect, useState } from "react";
import { Row, Col, Button, Input, Label, FormGroup } from "reactstrap";
import { Plus, Minus } from "react-feather";
import { getVendorSettings, setVendorData } from "../../../services/helper";
import { toast } from "react-toastify";
import http from "../../../services/http";

export default function TierDiscounts() {
  const discount_reset_options = [
    { value: "", label: "Select reset period" },
    { value: "1month", label: "1 month" },
    { value: "6months", label: "6 months" },
    { value: "12months", label: "12 months" },
    { value: "never", label: "Never" },
  ];

  const [tiers, setTiers] = useState([]);
  const [discountReset, setDiscountReset] = useState("");

  useEffect(() => {
    const tierDiscounts = getVendorSettings("tierDiscounts") || {
      tiers: [],
      discount_reset: "",
    };

    setTiers(tierDiscounts.tiers || []);
    setDiscountReset(tierDiscounts.discount_reset || "");
  }, []);

  const handleAddTier = () => {
    setTiers([...tiers, { points: "", discount: "", label: "" }]);
  };

  const handleRemoveTier = (index) => {
    setTiers(tiers.filter((_, i) => i !== index));
  };

  const handleTierFieldChange = (index, field, value) => {
    const updatedTiers = [...tiers];
    updatedTiers[index][field] = value;
    setTiers(updatedTiers);
  };

  const onDiscountResetChange = (e) => {
    setDiscountReset(e.target.value);
  };

  const handleSaveSettings = async () => {
    const data = {
      tierDiscounts: {
        tiers,
        discount_reset: discountReset,
      },
    };

    try {
      const { data: newSettings } = await http.saveVendorData(data);
      setVendorData(newSettings);
      toast.success("Tier discounts saved successfully!");
    } catch (error) {
      console.error("Error saving tier discounts:", error);
      toast.error("Failed to save tier discounts.");
    }
  };

  return (
    <div style={{ maxHeight: "70vh", overflowY: "auto", padding: "0 1rem" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">Discount Tiers</h5>
        <Button color="primary" size="sm" onClick={handleAddTier}>
          <Plus size={16} />
        </Button>
      </div>

      {tiers.map((tier, index) => (
        <Row key={index} className="align-items-center mb-2">
          <Col xs={4}>
            <Input
              type="number"
              bsSize="sm"
              placeholder="Points"
              value={tier.points}
              onChange={(e) =>
                handleTierFieldChange(index, "points", e.target.value)
              }
            />
          </Col>
          <Col xs={3}>
            <Input
              type="number"
              bsSize="sm"
              placeholder="Discount %"
              value={tier.discount}
              onChange={(e) =>
                handleTierFieldChange(index, "discount", e.target.value)
              }
            />
          </Col>
          <Col xs={4}>
            <Input
              type="text"
              bsSize="sm"
              placeholder="Label"
              value={tier.label}
              onChange={(e) =>
                handleTierFieldChange(index, "label", e.target.value)
              }
            />
          </Col>
          <Col xs={1} className="text-center">
            <Button
              color="danger"
              size="sm"
              onClick={() => handleRemoveTier(index)}
              className="px-1 py-0"
            >
              <Minus size={14} />
            </Button>
          </Col>
        </Row>
      ))}

      <FormGroup row className="mt-3">
        <Label for="discount_reset" sm={4}>
          Reset After
        </Label>
        <Col sm={8}>
          <Input
            type="select"
            name="discount_reset"
            id="discount_reset"
            bsSize="sm"
            value={discountReset}
            onChange={onDiscountResetChange}
          >
            {discount_reset_options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </Col>
      </FormGroup>

      <div className="text-end mt-2">
        <Button size="sm" color="success" onClick={handleSaveSettings}>
          Save
        </Button>
      </div>
    </div>
  );
}
